export default {"src":"/newStatic/_next/static/media/tradeillus.607f2bb4.svg","height":294,"width":650};